<script lang="ts">
  import { ProductPage, type ProductLoadResponse } from '@glimja/storefront/pages';
  const { data }: { data: ProductLoadResponse } = $props();
</script>

<ProductPage data={data} />
